// Render cột "Mã giảm giá" của bảng bài cộng đồng — dùng chung cho bảng bài đã
// duyệt (community-post-columns) và bảng chờ duyệt (community-pending-columns).
// 1 bài có thể tới 10 mã (backend: services/community-post-helpers.js) nên cột
// hẹp sẽ cao lêu nghêu (mã dài ~8-10 ký tự, 3 tag là vỡ dòng) -> chỉ hiện 1 tag
// trên 1 dòng, phần còn lại gom "+N"; tooltip liệt kê ĐỦ mọi mã.
import React from "react";
import { Tag, Tooltip } from "antd";

const VISIBLE_TAGS = 1;

export function renderDiscountTags(code) {
    const codes = String(code || "")
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    if (codes.length === 0) return <span className="text-content-3">—</span>;

    const hiddenCount = codes.length - VISIBLE_TAGS;
    return (
        <Tooltip title={hiddenCount > 0 ? codes.join(", ") : null}>
            <span style={{ whiteSpace: "nowrap" }}>
                {codes.slice(0, VISIBLE_TAGS).map((item) => (
                    <Tag color="gold" key={item} style={{ marginInlineEnd: 4 }}>
                        {item}
                    </Tag>
                ))}
                {hiddenCount > 0 && <Tag style={{ marginInlineEnd: 0 }}>+{hiddenCount}</Tag>}
            </span>
        </Tooltip>
    );
}

export default renderDiscountTags;
